<template>
    <loading-spinner v-if="loading"/>
    <v-container v-else-if="coach">

        <v-row>
            <!-- BACK BUTTON -->
            <v-col cols="12">
                <back-button fixed/>
            </v-col>
            <!-- IMG -->
            <v-col cols="12" class="pt-0">
                <v-img
                    eager contain
                    :lazy-src="imgPlaceholder"
                    height="200"
                    class="img-profile"
                    :src="coachImg"
                />
            </v-col>
            <!-- COACH INFO -->
            <v-col cols="12">
                <div class="name-section">
                    {{ coach.name }}
                </div>
                <div class="description-section" v-if="coach.description">
                    {{ coach.description || '' }}
                </div>
                <div class="sports-section" v-if="coachSports">
                    {{ coachSports }}
                </div>
            </v-col>
            <!-- PROFESSIONAL INFO -->
            <v-col cols="12">
                <v-row class="title-section" align="center" v-if="hasInfo" @click="hideInfo = !hideInfo" v-ripple>
                    {{ $t('coach.professional_info') }}
                    <v-spacer/>
                    <v-icon>{{ chevronIcon }}</v-icon>
                </v-row>

                <v-divider v-if="hasInfo"/>

                <div :class="{'d-none': hideInfo }" v-if="hasInfo">
                    <span class="experience-section" v-if="coach.experience">
                        {{ coach.experience }} {{ $t('coach.experience_years') }}
                    </span>
                    <br>
                    <span class="text-body-2">
                        {{ coach.professional_preparation }}
                    </span>
                </div>
            </v-col>
            <!-- TRAINED STUDENTS -->
            <v-col cols="12" v-if="lastStudents.length > 0">
                <v-row class="title-section" align="center">
                    {{ $t('coach.trained_with') }}
                    <v-spacer/>
                    ({{ trainedStudents }})
                </v-row>
                <v-divider/>
            </v-col>
            <v-col v-for="(student,i) in lastStudents" :key="i" cols="12" md="4">
                <mini-student-card :student="student"/>
            </v-col>
        </v-row>

        <v-sheet height="16" color="transparent"/>

        <!-- BOTTOM BUTTONS -->
        <div :class="[{'bottom-button': isMobile}]">
            <v-row v-if="isMyCoach">
                <v-col cols="12" md="6" offset-md="6" align="right">
                    <v-btn @click="showRoutines" color="primary" class="normal-btn black--text mr-1" style="width: 69%"
                           depressed large>
                        {{ $t('coach.see_routines') }}
                    </v-btn>
                    <v-btn @click="showChat" color="backGroundSecondary" style="width: 29%" depressed large>
                        <v-icon class="border-icon" color="white">mdi-message-processing</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" align="right">
                    <v-btn @click="showChat" color="primary" class="normal-btn black--text" :block="isMobile" depressed
                           large>
                        <v-icon left class="border-icon" color="white">mdi-message-processing</v-icon>
                        {{ $t('coach.send_message') }}
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <chat-dialog :clientId="coachId" ref="chat"></chat-dialog>

    </v-container>
</template>

<script>

import ChatDialog from '@/components/student/ChatDialog'

import {db} from '@/utils/Firebase'
import BackButton from "@/components/common/BackButton";
import MiniStudentCard from "@/components/elements/cards/MiniStudentCard";
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    components: {
        LoadingSpinner,
        MiniStudentCard,
        BackButton,
        ChatDialog
    },
    data() {
        return {
            hideInfo: false,
            coach: null,
            loading: false,
            lastStudents: [],
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.$route.params.uid
        },
        chevronIcon(vm = this) {
            return vm.hideInfo ? 'mdi-chevron-up' : 'mdi-chevron-down'
        },
        coachSports(vm = this) {
            return vm.coach?.sport_areas?.join(', ') || ''
        },
        isMyCoach(vm = this) {
            return vm.account.stripeAccount?.currentSubscription?.coachId === vm.coachId
        },
        coachImg(vm = this) {
            return vm.coach?.avatar || vm.imgPlaceholder
        },
        trainedStudents(vm = this) {
            if (!vm.coach.trainedStudents) return '00'
            if (vm.coach.trainedStudents < 10) return `0${vm.coach.trainedStudents}`
            return vm.coach.trainedStudents
        },
        hasInfo(vm = this) {
            return vm.coach.experience || vm.coach.professional_preparation
        }
    },
    async mounted() {
        const vm = this
        await vm.loadCoach()
    },
    methods: {
        showChat() {
            const vm = this
            vm.$refs.chat.show()
        },
        showRoutines() {
            const vm = this
            vm.$router.push({name: 'student.routines'})
        },
        async loadCoach() {
            const vm = this
            vm.loading = true
            vm.lastStudents = []
            let coachRef = await db.collection('users').doc(vm.coachId).get()
            vm.coach = coachRef.data()

            if (vm.coach?.lastStudents?.length > 0) {
                let lastStudents = []
                for (let studentId of vm.coach.lastStudents) {
                    let studentRef = await db.collection('users').doc(studentId).get()
                    lastStudents.push({id: studentRef.id, ...studentRef.data()})
                }
                vm.lastStudents = lastStudents
            }
            vm.loading = false
        }
    },
}
</script>

<style scoped>


.bottom-button {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 15px;
    background-color: #FFFFFF;
    border-top: 1px solid #333333;
    z-index: 6;
}

.img-profile {
    left: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    max-width: 100vw;
    position: relative;
    right: 50%;
    margin-top: -36px;
    background-color: #ffffff;
    border-top: 2px solid var(--v-primary-base);
    border-bottom: 2px solid var(--v-primary-base);
}

.v-divider {
    height: 2px;
    max-height: 10px;
    background-color: var(--v-primary-base);
    margin-top: 10px;
    margin-bottom: 10px;
}

.title-section {
    color: #666666;
    font-size: 17px;
    padding: 12px;
}

.name-section {
    color: var(--v-accent-base);
    font-size: 20px;
    line-height: 22px;
    font-weight: bold;
    text-align: center;
}

.description-section {
    color: #707070;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
}

.sports-section {
    color: #333333;
    font-size: 13px;
    line-height: 17px;
    text-align: center;
}

.experience-section {
    color: var(--v-accent-base);
    font-size: 15px;
    font-weight: bold;
}

.border-icon {
    text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
}

</style>